

















































































import { Component, Mixins } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Mutations, Actions, GlobalOverlays } from '@/ts/store/Constants';
import DateMethods from '@/mixins/DateMethods.vue';
import TicketHelper from '@/mixins/TicketHelper.vue';

@Component({
    computed: {
        ...mapGetters({
            allUserTickets: 'UserTickets/getAllUserTickets',
        }),
    },
})
export default class TenantTicketsList extends Mixins(DateMethods, TicketHelper) {
    constructor() {
        super();
    }

    public addNewTicketTypeModal()  {
        this.$store.commit(Mutations.SET_GLOBAL_OVERLAY_VISIBILITY, true);
        this.$store.commit(Mutations.SET_GLOBAL_OVERLAY_COMPONENT, GlobalOverlays.TICKET_TYPE);
        this.$store.commit(Mutations.SET_GLOBAL_OVERLAY_WAS_OPENED_LOCALLY, true);
    }

    public previewCurrentTicket(ticketId: number)  {
        this.$store.dispatch(Actions.FETCH_USER_CURRENT_TICKET, {id: ticketId, chat: false});
    }

    public openTicketChat(ticket: any) {
        this.$store.dispatch(Actions.FETCH_USER_CURRENT_TICKET, {id: ticket.id, chat: true});
    }
}
